import Vue from "vue";
import { Data, Lifecycle, Component } from "vuety";
import {
	IProductGroupOptions,
	IProductGroupContainer,
	IProductGroupItem,
} from "./interfaces";

@Component({
	template: "<span style='display:none'></span>",
})
export class Root extends Vue {
	@Data()
	public currentGroup: string;
	@Data()
	public searchTerm: string;
	@Data()
	public currentData: IProductGroupContainer;
	@Data()
	public ajaxUrl: string;

	private loading: boolean = false;

	@Lifecycle()
	created() {
		$(window).on("popstate", (e) => {
			this.currentGroup = (e.originalEvent as PopStateEvent).state;
		});
	}

	public setCurrentGroup(
		options: IProductGroupOptions,
		data?: IProductGroupItem,
		pushState?: boolean
	) {
		if (data) {
			if (window.ProductGroupsPlugin.spaNavigate) {
				if (pushState) {
					history.pushState(
						data.GroupCode,
						data.GroupName,
						getGroupLinkUrl(options, data)
					);
				}
				if (window.ProductGroupsPlugin.pageTitleTemplate) {
					document.title = window.ProductGroupsPlugin.pageTitleTemplate.replace(
						"[Product Groups]",
						data.PageTitle
					);
				}
			}
			this.currentGroup = data.GroupCode;
		} else {
			if (this.currentGroup) {
				if (window.ProductGroupsPlugin.spaNavigate && pushState) {
					history.pushState("", "", options.groupPage);
				}
			}
			if (window.ProductGroupsPlugin.pageTitleTemplate) {
				document.title = window.ProductGroupsPlugin.pageTitleTemplate.replace(
					"[Product Groups]",
					"Product Groups"
				);
			}
			this.currentGroup = "";
		}
	}

	public loadData(options: IProductGroupOptions) {
		this.ajaxUrl = options.resourceUrl + "&file=productgroups.json";
		if (!this.searchTerm) {
			this.searchTerm = getQueryStringValue("description");
		}
		if (!this.currentData) {
			if (!this.loading) {
				this.loading = true;
				if (options.noCache) {
					$.ajaxSetup({ cache: false });
				}

				$.getJSON(this.ajaxUrl)
					.done((data: IProductGroupContainer) => {
						this.currentData = data;

						if (!this.currentGroup) {
							this.setCurrentGroup(
								options,
								findChild(options.startingGroup, this.currentData.Groups)
							);
						}
					})
					.fail((jqXHR, textStatus, errorThrown) => {
						console.log(
							"Product Item Group data load error",
							textStatus,
							errorThrown
						);
					});
			}
		}
	}
	public currentGroupObject(options: IProductGroupOptions): IProductGroupItem {
		if (this.currentGroup) {
			return findChild(
				this.currentGroup,
				this.currentData.Groups
			) as IProductGroupItem;
		} else {
			if (options.rootGroup && this.currentData) {
				const root = findChild(options.rootGroup, this.currentData.Groups);
				if (!root) {
					console.warn(
						"No group data found for root group:",
						"'" + options.rootGroup + "'.",
						"This may be because the group is obsolete."
					);
				}
				return root || ({} as IProductGroupItem);
			} else {
				return {} as IProductGroupItem;
			}
		}
	}
	public currentGroupChildren(
		options: IProductGroupOptions
	): IProductGroupItem[] {
		if (!this.currentGroup) {
			if (options.rootGroup) {
				const child = findChild(options.rootGroup, this.currentData.Groups);
				if (!child || !child.Children) {
					console.warn(
						"No group data found for root group:",
						"'" + options.rootGroup + "'.",
						"This may be because the group is obsolete."
					);
					return [];
				}
				return child.Children;
			} else {
				return this.currentData.Groups;
			}
		} else {
			return this.currentGroupObject(options).Children || [];
		}
	}
}

const $root = new Root();

export function getRoot(): Root {
	return $root;
}

export function getGroupImageUrl(
	options: IProductGroupOptions,
	data: IProductGroupItem
): string {
	if (data.ImageVersion === null || +data.ImageVersion <= -1) {
		return (
			"/streamProductImage.aspx?type=GROUPS&ref=noimage.jpg" +
			options.imgResizerArgs
		);
	} else {
		return (
			"/streamProductImage.aspx?type=GROUPS&ref=" +
			data.ImageName +
			options.imgResizerArgs +
			"&ver=" +
			data.ImageVersion
		);
	}
}

export function getGroupLinkUrl(
	options: IProductGroupOptions,
	data: IProductGroupItem
): string {
	if (data.Children && data.Children.length > 0 && data.Items === 0) {
		return options.groupPageMask.replace(
			"[GroupCode]",
			encodeURIComponent(data.GroupCode)
		);
	} else {
		return options.productListPageMask.replace(
			"[GroupCode]",
			encodeURIComponent(data.GroupCode)
		);
	}
}

function getQueryStringValue(key: string): string {
	return decodeURIComponent(
		window.location.search.replace(
			new RegExp(
				"^(?:.*[&\\?]" +
					encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") +
					"(?:\\=([^&]*))?)?.*$",
				"i"
			),
			"$1"
		)
	);
}

export function findChild(
	groupCode: string,
	data: IProductGroupItem[]
): IProductGroupItem | undefined {
	if (data) {
		for (let i = 0; i < data.length; i++) {
			if (
				groupCode !== null &&
				data[i].GroupCode.toLowerCase() === groupCode.toLowerCase()
			) {
				return data[i];
			} else {
				const child = findChild(groupCode, data[i].Children);
				if (child) {
					return child;
				}
			}
		}
	}
	return undefined;
}



// WEBPACK FOOTER //
// ./src/root.ts